// About.jsx
import React from "react";
import { motion } from "framer-motion";
import { FaReact, FaDatabase, FaCode } from "react-icons/fa";
import profileImage from "../assets/undraw_web-developer_ggt0.svg"

const About = () => {
  return (
    <section
      id="about"
      className="py-16 text-gray-800 bg-white dark:bg-gray-900 dark:text-gray-200 scroll-smooth"
    >
      <div className="flex flex-col items-center max-w-6xl gap-12 px-6 mx-auto lg:px-8 md:flex-row">
      
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="flex justify-center w-full md:w-1/2"
        >
          <img
            src={profileImage}
            alt="Profile"
            className="object-cover transition-transform duration-300 shadow-lg rounded-2xl w-72 md:w-96 hover:scale-105"
          />
        </motion.div>

        
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="w-full md:w-1/2"
        >
          <h2 className="mb-6 text-3xl font-bold md:text-4xl">
            About <span className="text-blue-600">Me</span>
          </h2>
          <p className="mb-6 text-lg leading-relaxed">
            Hi, I’m <span className="font-semibold">Muhammad Shaheer Haider</span>, 
            a passionate <span className="text-blue-600">Frontend Developer</span> with expertise in 
            building modern, responsive web applications using 
            <span className="font-semibold"> React, Firebase, Redux, and Tailwind CSS</span>.  
            I love creating clean UI/UX with animations and interactivity that bring websites to life.
          </p>

         
          <div className="grid grid-cols-1 gap-6 mb-8 sm:grid-cols-3">
            <div className="p-6 text-center transition-transform duration-300 bg-gray-100 shadow dark:bg-gray-800 rounded-xl hover:scale-105">
              <FaCode className="mx-auto mb-2 text-3xl text-blue-600" />
              <h3 className="text-lg font-bold">10+ Projects</h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Completed with React & Firebase
              </p>
            </div>
            <div className="p-6 text-center transition-transform duration-300 bg-gray-100 shadow dark:bg-gray-800 rounded-xl hover:scale-105">
              <FaReact className="mx-auto mb-2 text-3xl text-blue-600" />
              <h3 className="text-lg font-bold">Frontend Focused</h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Strong in React.js & UI/UX
              </p>
            </div>
            <div className="p-6 text-center transition-transform duration-300 bg-gray-100 shadow dark:bg-gray-800 rounded-xl hover:scale-105">
              <FaDatabase className="mx-auto mb-2 text-3xl text-blue-600" />
              <h3 className="text-lg font-bold">Firebase Ready</h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Auth, Firestore, Hosting
              </p>
            </div>
          </div>

         
          <div className="flex gap-4">
            <button
              type="button"
              className="px-6 py-3 text-white transition bg-blue-600 shadow rounded-xl hover:bg-blue-700"
              onClick={() => {
                const el = document.getElementById('projects');
                if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }}
            >
              View Projects
            </button>
            <a
              href="/cv/ShaheerDev-Resume.pdf" 
              className="px-6 py-3 text-blue-600 transition border border-blue-600 shadow rounded-xl hover:bg-blue-600 hover:text-white"
              download="M.ShaheerHaider_Resume.pdf"
            >
              Download CV
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
